<template>
  <div class="privacy-settings-contenier">
    <div class="privacy-settings-title">
      CHANGE PASSWORD
    </div>
    <form
      v-on:submit="saveChangedPassword"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="privacy-settings-body bv-example-row">
        <b-alert
          :show="showErrorAlert"
          dismissible
          variant="danger"
          @dismissed="showErrorAlert=false"
        >
          <span>
            <ul>
              <li
                v-for="(err, i) in error"
                :key="i"
              >
                {{ err }}
              </li>
            </ul>
          </span>
        </b-alert>
        <br v-if="showErrorAlert">
        <b-row class="justify-content-center">
          <b-col xl="4" lg="5" md="7" sm="9" class="justify-content-center">
            <label class="change-password-label">Type the old password*</label>
            <b-input-group>
              <b-input-group-text
                slot="append"
                class="eye-icon-block"
              >
                <i
                  @click="showPassword('oldPassword')"
                  :class="oldPasswordType === 'password' ?'far fa-eye':'far fa-eye-slash'"
                ></i>
              </b-input-group-text>
              <b-form-input
                v-validate="'required|min:8'"
                name="old password"
                :type="oldPasswordType"
                v-model="oldPassword"
                id="oldPassword"
                :class="{ 'is-danger': errors.has('old password') }"
                class="password-input"
              ></b-form-input>
            </b-input-group>
            <small
              v-if="errors.has('old password')"
              class="field-text is-danger"
            >
              {{ errors.first('old password') }}
            </small>
          </b-col>
        </b-row>
        <b-row class="mt-sm-2 justify-content-center">
          <b-col xl="4" lg="5" md="7" sm="9" class="justify-content-center">
            <label class="change-password-label">Type the new password*</label>
            <b-input-group>
              <b-input-group-text
                slot="append"
                class="eye-icon-block"
              >
                <i
                  @click="showPassword('newPassword')"
                  :class="newPasswordType === 'password' ?'far fa-eye':'far fa-eye-slash'"
                ></i>
              </b-input-group-text>
              <b-form-input
                v-validate="'required|min:8'"
                ref="password"
                name="password"
                :type="newPasswordType"
                v-model="password"
                id="password"
                :class="{ 'is-danger': errors.has('password') }"
                class="password-input"
              ></b-form-input>
            </b-input-group>
            <small
              v-if="errors.has('password')"
              class="field-text is-danger"
            >
              {{ errors.first('password') }}
            </small>
          </b-col>
        </b-row>
        <b-row
          v-if="password.length"
          class="mt-sm-2 justify-content-center"
        >
          <b-col xl="4" lg="5" md="7" sm="9" class="justify-content-center">
            <label class="change-password-label">Repeat new password*</label>
            <b-input-group>
              <b-input-group-text
                slot="append"
                class="eye-icon-block"
              >
                <i
                  @click="showPassword('repeatPassword')"
                  :class="repeatPasswordType === 'password' ?'far fa-eye':'far fa-eye-slash'"
                ></i>
              </b-input-group-text>
              <b-form-input
                v-validate="'required|confirmed:password'"
                data-vv-as="password"
                name="repeat password"
                :type="repeatPasswordType"
                v-model="repeatPassword"
                id="repeat-password"
                :class="{ 'is-danger': errors.has('repeat password') }"
                class="password-input"
              ></b-form-input>
            </b-input-group>
            <small
              v-if="errors.has('repeat password')"
              class="field-text is-danger"
            >
              {{ errors.first('repeat password') }}
            </small>
          </b-col>
        </b-row>
      </div>
      <b-row class="privacy-settings-body justify-content-center">
        <b-col xl="4" lg="5" md="7" sm="9" class="mb-2 pb-2 justify-content-center">
          <div class="privacy-settings-support-text">
            <a
              class="privacy-settings-support-text"
              href="mailto:info@carriercommunity.com?subject=Support&cc=Kara@carriercommunity.com;w.schmidt@carriercommunity.com"
            > Need support? Click here!
            </a>
          </div>
        </b-col>
        <b-col lg="10" md="12" sm="12" class="justify-content-center">
          <b-button
            :class="isAllValid ? 'privacy-setting-button' : 'invalidButton'"
            block
            :disabled="!isAllValid"
            type="submit"
          >SAVE NEW PASSWORD</b-button>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'UserChangePassword',
  components: {
  },
  data() {
    return {
      oldPasswordType: 'password',
      newPasswordType: 'password',
      repeatPasswordType: 'password',
      error: null,
      showErrorAlert: false,
      oldPassword: '',
      password: '',
      repeatPassword: '',
      isAllValid: false,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  watch: {
    repeatPassword() { this.validateBeforeSubmit(); },
  },
  methods: {
    showPassword(passwordInput) {
      if (passwordInput === 'oldPassword') {
        if (this.oldPasswordType === 'password') {
          this.oldPasswordType = 'text';
        } else {
          this.oldPasswordType = 'password';
        }
      }
      if (passwordInput === 'newPassword') {
        if (this.newPasswordType === 'password') {
          this.newPasswordType = 'text';
        } else {
          this.newPasswordType = 'password';
        }
      }
      if (passwordInput === 'repeatPassword') {
        if (this.repeatPasswordType === 'password') {
          this.repeatPasswordType = 'text';
        } else {
          this.repeatPasswordType = 'password';
        }
      }
    },
    async validateBeforeSubmit() {
      this.isAllValid = await this.$validator.validate();
    },
    ...mapActions({
      changePassword: 'user/changePassword',
    }),
    async saveChangedPassword(evt) {
      evt.preventDefault();
      const { oldPassword, password, repeatPassword } = this;
      const isValide = await this.$validator.validate();
      if (isValide) {
        const data = {
          customer: this.userInfo.url,
          old_password: oldPassword,
          password,
          repeat_password: repeatPassword,
        };
        try {
          await this.changePassword(data);
          this.oldPassword = '';
          this.password = '';
          this.repeatPassword = '';
          this.$validator.reset();
          this.$notify({
            group: 'settings',
            title: 'Success',
            text: 'Your new password have been saved!',
            type: 'success',
          });
        } catch (e) {
          console.log(e);
          if (e.response) {
            this.error = e.response.data.non_field_errors;
            this.showErrorAlert = true;
          }
        }
      }
    },
  },
};
</script>
<style src='./Settings.css' scoped></style>
<style scoped>
.privacy-settings-body {
  background-color: white;
  padding: 20px;
}
.privacy-settings-contenier>form>div:last-child {

  margin: 0.5rem 0 auto 0;

}
.privacy-settings-contenier {

  margin-top: 0.25rem;

}

.privacy-settings-title {

  display: none;

}
.privacy-settings-support-text {
  font-family: Arial;
  font-size: 15px;
  line-height: 1.13;
  text-align: center;
  color: #BD9D5F;
}
.privacy-setting-button {
  margin: 0.4rem 0 20px 0;
  padding: 10px;
  font-family: Arial;
  font-size: 15px;
  line-height: 1.13;
  color: #BD9D5F;
  background: white;
  border: 1px solid #BD9D5F;
  text-align: center;
}
.privacy-setting-button:hover {
  color: #ffffff;
  background: #BD9D5F;
  border: unset;
}
.invalidButton {
  cursor: default;
  padding: 10px;
  background-color: #dbdbdb !important;
  border: unset !important;
}
.set-pass-input {
  font-family: Arial;
  font-size: 12px;
  text-align: left;
  color: #333333;
  box-shadow: none !important;
  border-radius: 2px;
  border: solid 1px #aaaaaa;
}
.privacy-settings-contenier {
  margin-top: 0.25rem;
}
.privacy-settings-title {
  display: none;
}
.privacy-settings-contenier .field-text {
  font-family: Arial;
  font-size: 12px;
  text-align: left;
  color: #ff0000;
  transition: 0.5s;
}
.change-password-label {
  font-family: Arial;
  font-size: 11px;
  line-height: 1.09;
  text-align: left;
  color: #666666;
}
.password-input {
  box-shadow: none;
  border: 1px solid #aaaaaa;
  border-right: none;
  height: 30px;
}
.password-input:focus {
  border-color: #aaaaaa;
  box-shadow: none;
}
.privacy-settings-contenier>form>div:last-child {
  margin: 0.5rem 0 auto 0;
}
.eye-icon-block {
  height: 30px;
  padding: 6px;
  background-color: transparent;
  border: 1px solid #aaaaaa;
  border-left: none;
}
.far{
  cursor: pointer;
}
@media (max-width: 1024px) {
  .eye-icon-block i {
    color: #666;
  }
  .privacy-settings-contenier {
    margin-top: 0.5rem;
  }
  .privacy-settings-title {
    display: block;
    padding: 16px;
    border-radius: 0 10px 0 0;
    text-align: center;
    background-color: #fff;
    margin-bottom: 2px;
    color: #666;
  }
  .privacy-settings-contenier>form>div:last-child {
    border-radius: 0 0 10px 10px;
    margin-top: 2px;
  }
  .privacy-setting-button, .invalidButton {
    border-radius: 0 10px 10px 10px;
  }
}
</style>
